<ul class="to_do">
  <ng-container *ngFor="let item of items">
    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
  </ng-container>
</ul>
<div *ngIf="items && items.length == 0">
  <ng-content select="ap-checklist-empty"></ng-content>
</div>
